import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row ml-1" }
const _hoisted_2 = { class: "ml-5" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "shade-input" }
const _hoisted_5 = {
  key: 0,
  style: {"padding":"4px","display":"inline-flex","overflow":"hidden","flex-wrap":"wrap"}
}
const _hoisted_6 = ["value", "title", "disabled", "onInput"]
const _hoisted_7 = { class: "shade-name" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopupComp = _resolveComponent("PopupComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option.Id
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(option.name), 1),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.inputData[option.name] != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputData[option.name], (colors) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "shade",
                      key: colors.value,
                      style: {"display":"flex","overflow":"hidden"}
                    }, [
                      _createElementVNode("input", {
                        class: "shade-color",
                        type: "color",
                        id: "favcolor",
                        name: "favcolor",
                        value: colors.value,
                        title: colors.name,
                        disabled: colors.isUsed || !_ctx.isActive,
                        onInput: ($event: any) => (_ctx.$emit('editShade', _ctx.handleEmit($event.target), option.name, colors.value, colors.name)),
                        "aria-label": 'favColor'
                      }, null, 40, _hoisted_6),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(colors.name), 1),
                      (!colors.isUsed && _ctx.isActive)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "close k-icon k-i-close",
                            onClick: ($event: any) => (_ctx.$emit('handleRemoveShade', option.name, colors.value))
                          }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (_ctx.isActive)
                    ? (_openBlock(), _createBlock(_component_PopupComp, {
                        key: 0,
                        option: option,
                        onHandleshadeAddition: _ctx.handleShade,
                        onInput: _ctx.handleEventName,
                        onInputValue: _ctx.handleEventValue
                      }, null, 8, ["option", "onHandleshadeAddition", "onInput", "onInputValue"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-primary",
            type: "submit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('handleUpdate')))
          }, _toDisplayString(_ctx.$t("shadingComp.update")), 1)
        ])
      ])
    ])
  ]))
}